import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FileText } from 'lucide-react';
import axios from 'axios';
import { API_BASE } from '../../config';

export default function RelatedEntries({ entryId }) {
    const [entries, setEntries] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!entryId) return;
        axios.get(`${API_BASE}/wiki/entries/${entryId}/related`)
            .then((res) => setEntries(res.data?.related || res.data?.entries || res.data || []))
            .catch(() => setEntries([]))
            .finally(() => setLoading(false));
    }, [entryId]);

    if (loading) {
        return <div style={{ color: 'var(--text-secondary)', fontSize: '0.8rem' }}>Loading related entries...</div>;
    }

    if (entries.length === 0) {
        return (
            <div style={{ color: 'var(--text-secondary)', fontSize: '0.8rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                <FileText size={14} /> No related entries found
            </div>
        );
    }

    return (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))', gap: '0.75rem' }}>
            {entries.map((entry) => (
                <Link
                    key={entry.id}
                    to={`/wiki/entry/${entry.slug || entry.id}`}
                    style={{
                        background: 'var(--bg-tertiary)',
                        border: '1px solid var(--border)',
                        borderRadius: '6px',
                        padding: '0.75rem',
                        textDecoration: 'none',
                        color: 'inherit',
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '0.25rem',
                        transition: 'border-color 0.2s',
                    }}
                    onMouseEnter={(e) => e.currentTarget.style.borderColor = 'var(--gold)'}
                    onMouseLeave={(e) => e.currentTarget.style.borderColor = 'var(--border)'}
                >
                    <div style={{ fontSize: '0.85rem', fontWeight: 600, color: 'var(--text-primary)' }}>
                        {entry.title || entry.title_en || 'Untitled'}
                    </div>
                    {entry.category && (
                        <div style={{ fontSize: '0.7rem', color: 'var(--text-secondary)' }}>
                            {entry.category}
                        </div>
                    )}
                </Link>
            ))}
        </div>
    );
}